import ConfiguratorRoute from "./ConfiguratorRoute";
export default ConfiguratorRoute;
